import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  deleteDropDownValueFormAction,
  showDropDownValueFormAction,
} from "../../Actions/Section&FieldAction/SectionFieldAction";
import { SlTrash } from "react-icons/sl";
import DeleteModal from "../../Modal/DeleteModal";
import { IoMdArrowRoundBack } from "react-icons/io";
import LoadingPage from "../Loading/LoadingPage";

const ShowValues = () => {
  const { id: fieldId } = useParams();
  const dispatch = useDispatch();
  const { items, loading } = useSelector((state) => state.showDropDwonValues);
  useEffect(() => {
    dispatch(showDropDownValueFormAction(fieldId));
  }, []);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(null);
  const [id, setId] = useState(null);
  const handleDelete = (id) => {
    setIsOpenDeleteModal(true);
    setId(id);
  };
  function handleOnDelete() {
    dispatch(deleteDropDownValueFormAction(id));
    dispatch(showDropDownValueFormAction(fieldId));
    dispatch(showDropDownValueFormAction(fieldId));
  }
  const navigate = useNavigate();
  return (
    <div className="bg-white mt-3 p-4 m-auto w-[95%] rounded-md shadow-md">
      <div className="flex gap-2 items-center justify-between">
        <button className="btn-indigo" onClick={() => navigate(-1)}>
          <IoMdArrowRoundBack /> Back
        </button>
        <div>
          <button className="btn-teal">Add +</button>
        </div>
      </div>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="parent-table">
          <table>
            <thead className="coustm-thead">
              <tr>
                <th className="coustm-th py-2 px-1">#</th>
                <th className="coustm-th py-2 px-1">Values</th>
                <th className="coustm-th py-2 px-1">Action</th>
              </tr>
            </thead>
            <tbody>
              {items?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.value}</td>
                    <td>
                      <button
                        onClick={() => handleDelete(item.id)}
                        className="btn-red"
                      >
                        Delete <SlTrash />
                      </button>
                    </td>
                  </tr>
                );
              })}
              <tr></tr>
            </tbody>
          </table>
        </div>
      )}

      <DeleteModal
        isOpen={isOpenDeleteModal}
        onClose={() => setIsOpenDeleteModal(false)}
        id={id}
        onDelete={handleOnDelete}
      />
    </div>
  );
};

export default ShowValues;
